$(document).ready(function() {
    let e = window.location.pathname;
    e = e.split("+"), 1 < e.length && 0 < $("#filter-count").length && ($("#filter-count").children("p").text(e.length - 1));
    const l = document.querySelectorAll(".collection-filter-sidebar"),
        t = document.querySelectorAll(".darken-bg");
    $(".navigation-header li.collection-filter-heading").on("click", function(e) {
        e.preventDefault(), $(l).addClass("expanded"), $("body").addClass("expanded"), $(t).addClass("expanded")
    }), 
      $(".collection-filter-sidebar .close-filter").on("click", function() {
        $(l).removeClass("expanded"), $("body").removeClass("expanded"), $(t).removeClass("expanded")
    }), $(document).mouseup(function(e) {
        $(l).is(e.target) || 0 !== $(l).has(e.target).length || $(l).hasClass("expanded") && ($(l).removeClass("expanded"), $(t).removeClass("expanded"), $("body").removeClass("expanded"))
    });
    document.querySelectorAll("[accordion] li a.filter-heading");
    $("[accordion] li a.filter-heading").on("click", function() {
        event.preventDefault();
        let e = $(this).siblings(".filter-options");
        e.hasClass("expanded") ? e.removeClass("expanded") : e.addClass("expanded")
    });
    const n = document.querySelectorAll("ul.sort-by li input");
    $("ul.filter-options li").on("click", function() {
        var e = $(this).children("input");
        $(this).parent().hasClass("sort-by") && ($(n).is(":checked") ? $(this).children("input")[0].value == $(n).filter(":checked")[0].value ? $(n).filter(":checked").prop("checked", !1) : ($(n).prop("checked", !1), $(e).prop("checked", !0)) : $(e).prop("checked", !0))
    });
    let o = [];

     function d(e, l) {
       let t, n;
       if (t = $("#collection").attr("data-collection-url"), e) {
         if (window.location.href.includes('view=all')) {
           for (var o in n = t + "/", e) {
             n += "+" + e[o];
           }
           n += "?sort_by=" + l + "&view=all";
         } 
         else {
           for (var o in n = t + "/", e) {
             n += "+" + e[o];
           }
           n += "?sort_by=" + l;
         }
       } else {
           if (window.location.href.includes('view=all')) {
             n = t + "?sort_by=" + l + "&view=all";
           } else {
             n = t + "?sort_by=" + l;
           }
       }
       window.location.href = n;
     }


    $(".apply-filters").on("click", () => {
        let e = document.querySelectorAll("ul.filter-options li input:checked");
        var l = document.querySelectorAll("ul.sort-by li input:checked"),
            l = (e.forEach(e => {
                  $(e).parent().parent().hasClass("sort-by") || o.push(e.value)
                }), 
                l.length ? l[0].value : $("ul.sort-by").attr("default-sort"));
                o.length ? d(o, l) : d(!1, l)
    }), 
      
      $(".reset-filters").on("click", () => {
        var e = $("#collection").attr("data-collection-url");
        window.location.href = e
    });
  
    const p = document.querySelectorAll("ul.filter-options li input");
    let u = [],
        a = [];
    var url = $(location).attr("href");
  
    if (url.includes("?view=all") || url.includes("&view=all")) {
        url = url.replace("?view=all", "").replace("&view=all", "");
    }
  
    var r = url.split("/");
    
    let c = r[r.length - 1],
        i = (c = c.replaceAll("#", ""), c.split("?"));
    for (var s = 0; s < i.length; s++) i[s] = i[s].replace("sort_by=", "");
    a.push(i[1]);
    for (var h = i[0].split("+"), s = 0; s < h.length; s++) a.push(h[s]);
    p.forEach(e => {
        u.push(e.value)
    });
    const f = a.filter(e => u.includes(e));
    f.forEach(e => {
        e = document.querySelectorAll('input[value="' + e + '"]');
        $(e).prop("checked", !0), $(e).parent().addClass("active"), $(e).parent().parent().hasClass("sort-by") || $(e).parent().parent().addClass("expanded")
    })
});
